import { Layout } from "../../../layouts/v1";
import { MainView } from "../../../views/return-exchange/register";

export function ReturnExchange_RegisterPage(props) {
    return (
        <>
            <Layout>
                <MainView />
            </Layout>
        </>
    );
}